import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import { useTable } from 'react-table';
import TablePreset from '../../../Table/TablePreset';
import UpdatePointsModal from '../CustomerModals/UpdatePointsModal';
import LoyaltyParticipationModal from '../CustomerModals/LoyaltyParticipationModal';
import ToastInfo from '../../../Toasts/ToastInfo';
import middleware from '../../../Api/Middleware';
import { ButtonLightGrey } from '../../../HouseStyle/Components/Buttons';

export default function Loyalty({ typeCustomer }) {
  const navigate = useNavigate();
  const { internal_id } = useParams();
  const [isChecked, setIsChecked] = useState(false);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({
    "page_size": 10,
    "page": 1,
    "max_items": 0,
    "begin_of_page": 0,
    "end_of_page": 0,
  });
  const [order, setOrder] = useState({ orderBy: '', direction: '' });
  const [showUpdatePointsModal, setShowUpdatePointsModal] = useState(false);
  const [mutations, setMutations] = useState([]);
  const [totalPoints, setTotalPoints] = useState([]);
  const [consumerData, setConsumerData] = useState({});
  const [showLoyaltyParticipationModal, setShowLoyaltyParticipationModal] = useState(false);
  const [updatedLoyalty, setUpdatedLoyalty] = useState(false);
  const [method, setMethod] = useState(null); // Whenever to add or subtract points
  const fetchAll = async () => {
    setLoading(true);
    try {
      const [mutationsResponse, loyaltyMutationsResponse, consumerResponse] = await Promise.all([
        middleware.get(`sp/consumerLoyaltyMutations?internal_id=${internal_id}&base=1&page=${pagination.page}&page_size=${pagination.page_size}`),
        middleware.get(`loyaltymutations?internal_id=${internal_id}`),
        internal_id.startsWith('C') ? middleware.get(`consumers?internal_id=${internal_id}`) : middleware.get(`businesses?internal_id=${internal_id}`)
      ])
      const { contact_persons, ...consumerDataWithoutContactPersons } = consumerResponse.data.data[0];
      setMutations(mutationsResponse.data.data);
      setTotalPoints(loyaltyMutationsResponse.data.data);
      setConsumerData(consumerDataWithoutContactPersons);
      setPagination({ ...pagination, "max_items": mutationsResponse.data.total, "begin_of_page": mutationsResponse.data.from, "end_of_page": mutationsResponse.data.to })
      setIsChecked(consumerResponse.data.data[0].has_loyalty === 1)
      setLoading(false);
    } catch (error) {
      console.error(error);
    }
  }

  useEffect(() => {
    fetchAll();
    setIsChecked(Number(consumerData.has_loyalty) === 1);
    setUpdatedLoyalty(false);
  }, [pagination.page_size, pagination.page, updatedLoyalty]);

  const openUpdatePointsModal = (method) => {
    setMethod(method);
    setShowUpdatePointsModal(true);
  }

  const handleCheckboxChange = (event) => {
    if (isChecked) {
      setShowLoyaltyParticipationModal(true);
    } else if (!isChecked) {
      if (consumerData.internal_id.startsWith('C')) {
        middleware.put('consumers', {
          ...consumerData,
          has_loyalty: 1,
        })
        ToastInfo(`Loyaliteits systeem ingeschakeld`);
      } else {
        middleware.put('businesses', {
          ...consumerData,
          has_loyalty: 1
        })
        ToastInfo(`Loyaliteits systeem ingeschakeld`);
      }
      setIsChecked(!isChecked)
    }
  };

  const [selectedIds, setSelectedIds] = useState([]);

  const handleDecision = (userDecision) => {
    if (userDecision) {
      if (consumerData.internal_id.startsWith('C')) {
        middleware.put('consumers', {
          ...consumerData,
          has_loyalty: 0
        });
        ToastInfo(`Loyaliteits systeem uitgeschakeld`);
      } else {
        middleware.put('businesses', {
          ...consumerData,
          has_loyalty: 0
        });
        ToastInfo(`Loyaliteits systeem uitgeschakeld`);
      }
    }
    setIsChecked(!userDecision);

    setShowLoyaltyParticipationModal(false);
  };

  const formatDate = (dateString) => {
    // Zet de invoerstring om in een Date-object
    const date = new Date(dateString);

    // Formatteer de datum in het gewenste formaat: dd-MM-yyyy
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Maanden zijn 0-gebaseerd
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  };


  const closeModalLoyaltyParticipation = () => {
    setShowLoyaltyParticipationModal(false);
  };

  const handleSelection = (productId, isSelected) => {
    if (isSelected) {
      setSelectedIds(previous => [...previous, productId]);
    } else {
      setSelectedIds(previous => previous.filter(id => id !== productId));
    }
  };

  const closeModalUpdatePoints = () => setShowUpdatePointsModal(false)

  const columns = useMemo(
    () => [
      {
        Header: () => (
          <div className='text-center fw-bold'>Datum</div>
        ),
        accessor: 'loyaltyCreatedDate',
        Cell: ({ row }) => {
          return (
            <div className="text-center">
              <p className='mb-0 text-nowrap'>{formatDate(row.original.created_date)}</p>
              <p>{row.original.created_time}</p>
            </div>
          )
        }
      },
      {
        Header: () => (
          <div className='text-center fw-bold'>Punten</div>
        ),
        accessor: 'loyaltyPoints',
        Cell: ({ row }) => {
          return (
            <div className="text-center">
              <p className='mb-0'>{row.original.points}</p>
            </div>
          )
        }
      },
      {
        Header: () => (
          <div className='text-center fw-bold'>Notitie</div>
        ),
        accessor: 'loyaltyNote',
        Cell: ({ row }) => {
          let note = row.original.note;
          if (row.original.note === "Onbekend") {
            note = row.original.other_reason;
          }
          return (
            <div className="text-center">
              <p className='mb-0'>{note}</p>
            </div>
          )
        }
      },
      {
        Header: () => (
          <div className='text-center fw-bold'>Bestellingnummer</div>
        ),
        accessor: 'loyaltyBestelling',
        Cell: ({ row }) => {
          return (
            <div className="text-center">
              {row.original.order_id ?
                <p className='mb-0 linkColor' onClick={() => navigate(`/bestellingen/overzicht/${row.original.order_number}`)}>{row.original.order_number}</p>
                :
                <p className='mb-0'>Handmatig toegevoegd</p>
              }
            </div>
          )
        }
      },
      {
        Header: () => (
          <div className='text-center fw-bold'>Medewerker</div>
        ),
        accessor: 'loyaltyOwner',
        Cell: ({ row }) => {
          return (
            <div className="text-center">
              <p className='mb-0'>{row.original.user}</p>
            </div>
          )
        }
      },
    ], [order.orderBy, order.direction, selectedIds, setSelectedIds, mutations]
  );

  // Table instance
  for (let i = 0; i < mutations.length; i++) {
    mutations[i].other_reason = [...totalPoints].reverse()[i].other_reason;
  }

  const tableInstance = useTable({ columns, data: mutations });

  if (loading) {
    return <h2 className="m-4 loader"></h2>
  }

  return (
    <>
      <UpdatePointsModal setUpdatedLoyalty={setUpdatedLoyalty} totalPoints={consumerData?.loyalty_points || 0} openUpdatePoints={showUpdatePointsModal} closeUpdatePoints={closeModalUpdatePoints} consumerData={consumerData} method={method} />
      <LoyaltyParticipationModal openLoyaltyParticipation={showLoyaltyParticipationModal} closeLoyaltyParticipation={closeModalLoyaltyParticipation} decision={handleDecision} />
      {isChecked ?
        <div className='p-4 pe-4 mb-3'>
          <div className='d-flex flex-row justify-content-between mb-3'>
            <div className='d-flex align-items-center flex-row gap-2'>
              <ButtonLightGrey text={"+ Punten Toevoegen"} textStyling={"BlackTextBold"} onClickFunction={() => openUpdatePointsModal(0)} />
              <ButtonLightGrey text={"- Gebruik / verwijder punten"} textStyling={"BlackTextBold"} disabled={!consumerData?.loyalty_points} onClickFunction={() => openUpdatePointsModal(1)} />
              {/* <button className='btn lightGrayStandardButton me-3' onClick={() => setShowAddPointsModal(true)}>+ Punten toevoegen</button>
              <button className='btn lightGrayStandardButton px-3' onClick={() => setShowRemovePointsModal(true)}>- Gebruik / verwijder punten</button> */}
            </div>
            <div className=''>
              <div className="d-flex flex-column align-content-center">
                <label className="fw-medium">Deelnemen</label>
                <label className="switchNewCustomer d-flex align-self-center">
                  <input
                    type="checkbox"
                    checked={isChecked}
                    onChange={handleCheckboxChange}
                  />
                  <span className="sliderNewCustomer round"></span>
                </label>
              </div>
            </div>
          </div>
          <div className='px-4'>
            <div>
              <p className='fw-medium mb-0'>Puntentotaal: {consumerData?.loyalty_points || 0}</p>
              <p className='fw-medium'>Aangemeld: {consumerData?.loyalty_signup_date ? consumerData.loyalty_signup_date : (consumerData?.created_at ? formatDate(consumerData.created_at) : 'N/A')}</p>
            </div>
            <div>
              <div className='loyaltyTable'>
                <div className="my-3 tablesCustomerEdit h-100">
                  <TablePreset
                    data={[
                      {
                        'tableInstance': tableInstance,
                        'pagination': pagination,
                        'primary_key': 'order_id'
                      }
                    ]}
                    setPagination={setPagination}
                    handleSelection={handleSelection}
                    noCheckbox={true}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        :
        <div className='p-4 pe-5 me-5 mb-3 d-flex flex-row justify-content-between'>
          <div>
            <p className='mb-0 fw-medium'>Deze klant maakt geen deel uit van het loyaliteitsprogramma.</p>
            <p className='fw-medium'>Hij/zijn zal zich automatisch aansluiten bij de eerste ontvangerspunten</p>
          </div>
          <div className='me-4'>
            <div className="d-flex flex-column align-content-center">
              <label className="fw-medium">Deelnemen</label>
              <label className="switchNewCustomer d-flex align-self-center">
                <input
                  type="checkbox"
                  checked={isChecked}
                  onChange={handleCheckboxChange}
                />
                <span className="sliderNewCustomer round"></span>
              </label>
            </div>
          </div>
        </div>
      }

    </>

  );
}
